import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-chart-paper-symbol-iec')
export class ObiChartPaperSymbolIec extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.847 3.86084C13.7629 4.17099 12.779 4.60724 11.83 5.22406C10.4778 6.103 8.75077 7.57108 7.16795 9.9453C5.51001 12.4322 4.83709 14.6983 4.58458 16.3653C4.48723 17.0079 4.45257 17.56 4.44741 18H2V20H9.17071C9.58254 21.1652 10.6938 22 12 22C13.3062 22 14.4175 21.1652 14.8293 20H22V18H20.45C20.4211 17.6374 20.3754 17.1859 20.3031 16.6624C20.1082 15.2503 19.7191 13.3043 18.9399 11.1587C18.1625 9.01768 17.2547 7.33061 16.5374 6.1739C16.0278 5.35228 15.4652 4.59944 14.847 3.86084ZM18.443 18C18.4166 17.7014 18.3781 17.3434 18.3219 16.9358C18.1418 15.6305 17.7809 13.8266 17.0601 11.8413C16.3375 9.85143 15.4953 8.2885 14.8376 7.22794C14.5762 6.80633 14.3444 6.46485 14.1615 6.20828C13.842 6.35608 13.4153 6.57899 12.92 6.90095C11.7722 7.647 10.2492 8.92893 8.83205 11.0547C7.35213 13.2746 6.77505 15.2585 6.56202 16.6648C6.48134 17.1974 6.45269 17.6487 6.44758 18H9.1707C9.58254 16.8348 10.6938 16 12 16C13.3062 16 14.4175 16.8348 14.8293 18H18.443ZM12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.847 3.86084C13.7629 4.17099 12.779 4.60724 11.83 5.22406C10.4778 6.103 8.75077 7.57108 7.16795 9.9453C5.51001 12.4322 4.83709 14.6983 4.58458 16.3653C4.48723 17.0079 4.45257 17.56 4.44741 18H2V20H9.17071C9.58254 21.1652 10.6938 22 12 22C13.3062 22 14.4175 21.1652 14.8293 20H22V18H20.45C20.4211 17.6374 20.3754 17.1859 20.3031 16.6624C20.1082 15.2503 19.7191 13.3043 18.9399 11.1587C18.1625 9.01768 17.2547 7.33061 16.5374 6.1739C16.0278 5.35228 15.4652 4.59944 14.847 3.86084ZM18.443 18C18.4166 17.7014 18.3781 17.3434 18.3219 16.9358C18.1418 15.6305 17.7809 13.8266 17.0601 11.8413C16.3375 9.85143 15.4953 8.2885 14.8376 7.22794C14.5762 6.80633 14.3444 6.46485 14.1615 6.20828C13.842 6.35608 13.4153 6.57899 12.92 6.90095C11.7722 7.647 10.2492 8.92893 8.83205 11.0547C7.35213 13.2746 6.77505 15.2585 6.56202 16.6648C6.48134 17.1974 6.45269 17.6487 6.44758 18H9.1707C9.58254 16.8348 10.6938 16 12 16C13.3062 16 14.4175 16.8348 14.8293 18H18.443ZM12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-chart-paper-symbol-iec': ObiChartPaperSymbolIec;
  }
}
